import { LiveFunctionCall } from '../GeminiLiveAPI/lib/multimodal-live-types'
import { NavigateArgs, resolveNavigateTargetOrThrow } from 'util/navigateUtils'

export const TOOL_NAME = 'navigate'

export { isSafeInAppPath, resolveNavigateTarget } from 'util/navigateUtils'

export function NavigateToolCall(functionCall: LiveFunctionCall, history: any) {
  const args = functionCall.args as NavigateArgs
  const target = resolveNavigateTargetOrThrow(args)

  history.push(target)

  return {
    success: true,
    pathname: target,
  }
}
